import { TabPanel } from "devextreme-react";
import { Item } from "devextreme-react/tab-panel";
import OtherAllowance from "./OtherAllowance";
import TaxFreeAllowance from "./TaxFreeAllowance";

export default function ExtraPay(props) {
  const renderTaxFree = () => {
    return <TaxFreeAllowance payrollSEQ={props.data.key} />;
  };

  const renderOther = () => {
    return <OtherAllowance payrollSEQ={props.data.key} />;
  };

  return (
    <TabPanel>
      <Item title="비과세 수당" render={renderTaxFree} />
      <Item title={"기타 수당"} render={renderOther} />
    </TabPanel>
  );
}
